import React from 'react'

import { useFormState } from '../../../../../packages/kiti/components/form/form/FormHandler'
import { Relative } from '../../../../../packages/kiti/components/helpers/Position'
import { Col, Grid } from '../../../../../packages/kiti/components/structure/Grid'
import FieldTypeIconText from '../../../../../containers/fields/FieldTypeIconText'
import Text from '../../../../../packages/kiti/components/presentation/Text'
import Panel from '../../../../../packages/kiti/components/structure/Panel'
import Draggable from '../../../../../components/dnd/Draggable'
import Droppable from '../../../../../components/dnd/Droppable'
import FieldInfoTags from './FieldInfoTags'
import FieldMenu from './FieldMenu'

const FieldPanel = ({ field, index }) => {
  const { markSelected, addIn, moveCloseTo } = useFormState()

  const isSelected = field.__selected
  const error = field.name__error
  let labelColor = 'light5'
  if (field.name) labelColor = 'dark2'
  else if (error) labelColor = 'red'

  const onDrop = (index, item, dir) => {
    if (!item.reference) {
      addIn([dir === 'DOWN' ? index + 1 : index], item, dir)
    } else {
      moveCloseTo([], item.reference, field.reference, dir)
    }
  }

  return (
    <Droppable type="FIELD" onDrop={({ item }, dir) => onDrop(index, item, dir)}>
      <Draggable type="FIELD" item={{ item: field }} hideOnDrag>
        <Panel
          marginV={0.3}
          onClick={() => markSelected([index])}
          width="100%"
          borderColor={isSelected ? 'primary' : 'light3'}
          borderWidth={isSelected ? '2px' : '1px'}
        >
          <Relative>
            <FieldMenu field={field} index={index} />
            <Grid justify="space-between" align="center" gutter={0.3}>
              <Col flex={1}>
                <Text color={labelColor}>
                  {field.name ||
                    error ||
                    (field.type === 'integration' && !field.name
                      ? 'Configure o campo da integração...'
                      : 'Adicionar rotulo...')}
                </Text>
              </Col>

              <FieldInfoTags field={field} />

              <Col width={9}>
                <FieldTypeIconText field={field} type={field.type} />
              </Col>
            </Grid>
          </Relative>
        </Panel>
      </Draggable>
    </Droppable>
  )
}

export default FieldPanel
